export function isTronAddress(address: string): boolean {
  if (address.length !== 34 || address[0] !== 'T') return false

  const base58 = /^[1-9A-HJ-NP-Za-km-z]+$/

  return base58.test(address)
}
